var _rect, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 600,
    fill: "#ffd520"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,600H900V0z",
    fill: "#ff4e12"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 0.5208
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m481.74,187.59c-4.9875-1.7708-8.2083,0.805-8.0458,7.2442,0.15833,6.4392,3.5417,10.142,8.5292,7.7271l-0.48334-14.971z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486.12,175.53c-4.1542-3.28-8.0292-1.8738-9.9458,4.2758-1.9167,6.1492,0.0958,10.742,5.5958,10.058l4.35-14.333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m493.04,163.86c-3.5792-3.9046-7.6292-3.1383-10.508,2.6246-2.875,5.7633-1.625,10.618,3.9167,10.825l6.5917-13.45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m488.5,220.59c-6.1167,2.2538-6.7625,10.625-2.8958,15.776,3.8625,5.1512,10.946,6.1171,14.808,0l-11.91-15.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m481.42,202.88c-5.7958-1.9317-11.017,5.8525-11.913,12.878-1.125,8.8538-13.683,11.751-6.7583,25.113,1.4458-8.5317,7.0833-13.2,11.588-13.522,4.5083-0.32208,11.271-1.2879,14.167-6.7613l-7.0833-17.708z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m499.77,237.33c-6.7625,1.6096-7.7292,10.625-2.9,17.064,4.1333,5.5129,17.063,4.1854,16.742-1.2879l-13.842-15.776z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m518.93,291.58c0.32084-5.795-9.0125-8.0488-13.521-6.9221-4.5083,1.1271-13.121-0.16083-15.133-4.9904-1.6083,3.8638,0.72501,8.0492,7.2458,10.142,4.9333,1.5846,4.8292,5.1512,3.3792,6.7613,3.7042,0.64375,14.65,0.64375,18.029-4.9904z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m513.62,254.56c-6.6-2.8975-10.513,1.5158-13.038,5.795-3.7042,6.2783-15.133-1.7704-18.996,6.6004,5.2333-2.2538,10.558,2.5525,13.038,4.1854,7.0833,4.6683,20.767,3.2196,22.7-7.7271l-3.7042-8.8538z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m517.48,262.28c-6.6,4.99-9.175,10.946-9.0125,14.971,0.1625,4.0246,5.7958,12.878,11.913,13.361,3.5417-7.2442,5.3125-22.537-2.9-28.332z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m490.12,293.35c0-2.4146,3.5417-3.3804,5.9542-2.5758,2.4167,0.805,6.1167,3.2196,4.8292,5.7954l-10.783-3.2196z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m453.73,280.15c-0.64167-2.8975,4.025-7.8879,10.304-5.1513,6.275,2.7367,7.0833,8.0492,4.5042,10.142l-14.808-4.9904z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m469.02,285.46c-0.48333-1.61,4.0375-4.8254,11.754-2.8979,7.725,1.9321,9.6208,6.9067,9.3375,10.786l-21.092-7.8879z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m452.93,280.15c4.025-3.0583,2.5-8.855-1.1292-10.625-6.6-3.2196-4.1833-11.59-8.3708-13.2-4.1833-1.61-8.2083-4.5075-8.3708-7.405-2.0917,4.0242-0.80417,7.7271,2.0958,10.303,2.8958,2.5758-2.2542,13.039,1.4458,15.776l14.329,5.1513z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.64,277.9c-3.3804-5.3121-11.43-4.3463-14.81-0.64375-3.3804,3.7025-2.8975,9.1758,0.32208,11.59l14.488-10.947z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m385.96,270.01c-1.2879-7.0829-9.82-7.8879-14.488-6.1171-4.6683,1.7708-7.8879,8.8538-4.8292,14.005l19.318-7.8879z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m398.84,269.04c3.0583-5.9563-2.8975-14.81-9.6588-16.098-5.6446-1.0738-12.315-1.0462-14.488-6.6-1.3683,4.8296,2.2542,7.8879,6.4396,10.625,4.185,2.7367-0.80542,9.82,5.9558,13.844l11.752-1.7708z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m398.2,269.25c-1.4088-4.2667,1.4488-9.9434,7.2325-9.5454,5.7842,0.39792,9.08,4.6013,6.53,9.8558l-13.763-0.31041z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m411.07,269.57c-0.79583-4.4221,2.83-9.6404,8.5008-8.435s8.3417,5.83,5.0833,10.675l-13.584-2.2396z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.86,271.6c-0.575-4.4575,3.3083-9.4875,8.9125-8.0013,5.6042,1.4871,8.0417,6.2404,4.5417,10.915l-13.454-2.9142z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.72,345.35c-10.786,0-13.42,2.5679-14.971,13.683-1.9317,13.844,16.903,15.454,14.971-13.683z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331.55,330.86c-16.581-6.2783-25.595,19.961-42.015,15.293,5.8754,9.3367,20.118,0.0167,25.434,0.96583,9.015,1.61,28.493-1.7708,16.581-16.259z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320.76,366.76c-8.21-3.7021-17.064,8.8542-15.454,14.327,2.0438,6.9521,20.766,1.2879,15.454-14.327z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.45,420.85c4.5075,1.2833,9.9804,3.8625,9.0146,12.554-0.96583,8.6917-17.385,26.4-32.195,27.367-14.81,0.96667-20.123,18.833-32.84,13.842,11.912-2.25,11.912-15.775,21.249-19.958-6.7612-2.4167-10.303,12.879-18.995,12.879-8.6929,0-12.878,13.842-23.503,12.875-10.625-0.9625-11.743,16.854-33,17.067-16.259,0.15834-36.381,19.154-43.625,10.946,15.776-2.2542,22.142-10.996,31.552-20.608,15.132-15.45,32.196-8.5292,37.991-22.213-6.9225,4.6667-14.971,6.9208-22.859,6.7625-9.9017-0.20417-20.766,15.775-31.874,8.6917,6.4392-0.80416,10.625-3.5417,17.386-10.625,6.9238-7.2542,17.083-2.5667,25.113-9.9792,12.556-11.592,23.342-1.9333,35.415-16.421-3.3808-1.6083-10.625-0.48334-17.386,3.0583-6.7613,3.5417-15.454-2.4167-23.181,1.7708,0.96583-9.4958,18.995-4.0625,30.264-10.625,12.718-7.4042,23.262-5.2333,33.323-4.3458-14.005-0.0792-19.478-13.363-38.795-9.5-8.425,1.6875-15.132-11.588-23.503-4.8292,0.24125-4.9875,9.015-9.0134,18.03-4.1833,9.0146,4.8292,12.648-4.2258,30.586,7.0833,7.405,4.6667,20.122-2.9,28.171,2.0917-1.0462-3.0583-5.6346-4.9917-11.027-4.5875,3.3808-6.9208,25.193-6.0375,34.691,0.8875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.78,410.38c-7.0829-5.4733-16.903,1.1283-23.664-1.4488,0,4.5062,2.2538,11.269,9.6588,13.844,2.2538-1.6083,12.395-10.463,14.005-12.395z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m307.89,394.77c-11.108-5.6342-13.039,8.3708-21.732,5.4733,0.32209,4.0246,3.5417,9.015,10.625,10.142l11.108-15.615z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.49,382.05c-16.42-6.4392-18.513,9.3367-28.171,6.2779,2.2538,5.4733,16.098,8.3708,23.181,6.4392l4.9904-12.717z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.02,312.99c-4.3467-6.1171-13.522-1.1267-14.971,6.1171-1.4488,7.2442,2.0925,17.386,8.21,15.132l6.7608-21.249z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.13,293.67c-7.5658-1.7704-16.259-0.96584-15.293,6.4392-2.8979,1.2879-3.7025,10.786,4.1854,12.878l11.108-19.318z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.12,288.68c-7.405-8.6929-15.663-8.4908-20.283-4.8296-8.5321,6.7613-16.823,2.8979-17.064,9.6588,5.1517-3.9438,9.6588,0.805,13.844-0.64375,4.1854-1.4488,7.2442,6.6,18.835,3.2196l4.6683-7.405z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m335.25,418.6c1.1271,2.0917,8.0488,3.0583,11.43-0.48334,4.4804-4.6958-0.48291-17.709-7.5663-18.675-7.0829-0.96583-7.7267,14.65-3.8633,19.158z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.2,418.92c10.141,3.7,14.488-4.6708,9.0146-9.9813-1.4488,1.7708-6.7613,8.2104-9.0146,9.9813z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289.21,432.76c-1.9321,5.7958-11.913,6.7625-23.181,24.792-11.269,18.029-22.054,10.463-24.791,22.858,13.522-10.946,24.142-3.675,32.195-14.488,12.235-16.421,22.309-14.063,27.045-25.113,6.7608-15.775,36.381-15.454,37.991-40.244-9.9808-1.9321-41.533,24.79-49.259,32.194z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m543.24,189.36c12.879,4.1854,13.2,20.927,28.008,26.4,14.813,5.4733,16.263,18.673,28.333,15.454-11.267-3.0588-10.463-16.098-22.213-19.318-13.783-3.7758-18.996-24.791-29.946-28.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m602.32,276.77c2.2542,5.1512,1.9333,14.327-6.1167,16.742,4.3458,2.7367,10.783,0.16084,14.325-5.795-5.3125,11.751-1.7708,22.376,6.6,24.469-4.025-8.21,4.9917-12.074,2.0958-17.386,5.3125,2.2538,9.9792,9.4979,9.8167,14.005,6.925-7.7271-5.15-18.03-2.8958-25.273l-23.825-6.7613z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m518.93,359.51c-7.8875-6.9221-11.254,1.8096-15.133-1.2075-3.6208-2.8171-8.45-3.2196-10.3-0.4025,6.7625,0.24167,3.4583,5.4733,16.579,6.7613-13.121,0.88541-10.704,15.535-19.479,14.81,9.3375,8.8538,14.167-7.8879,21.733-5.1512-2.2542,0.64375,3.5417,5.9562-0.48333,13.039,6.5208-0.16084,9.175-9.1758,9.9833-13.844l-2.9-14.005z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m345.23,434.69c-2.8979-2.4125-11.269-3.5417-14.488-1.6083-3.2192,1.9292-2.0925,2.4125,1.7708,2.7375,3.8638,0.32084,8.8525,6.5708,0.48291,6.9208-3.8633,0.15834-2.5754,9.4958-10.625,10.142,3.3,4.025,12.718,1.3667,16.098-3.0583-0.64375,3.6208,4.1854,6.9208,2.2538,11.267,5.9562,0.64584,2.495-12.071,11.913-11.429-3.8638,0.48334-2.2538,9.175,4.5071,6.9208-4.0242,1.9333-1.9317,6.6,2.5758,5.475-2.8975,0.96667-3.8638,4.6667,0.16084,6.7625,3.8638-5.3125-0.48292-24.308-14.649-34.129z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m695.85,257.07c12.321,0,22.308-9.9896,22.308-22.312,0-12.32-9.9875-22.31-22.308-22.31-12.325,0-22.313,9.99-22.313,22.31,0,12.322,9.9875,22.312,22.313,22.312z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m579.3,284.02c6.7625-6.4392,17.067-9.6588,24.146-4.8296,7.0833,4.8296,30.588,10.625,42.179,2.5758,11.588-8.0492,17.063-12.235,22.213-11.269,3.8667,5.7954,8.5334,8.5321,14.329,9.015,1.7708,1.9317,8.05,3.5417,11.592,3.0583,5.15,1.2879,11.429-0.32166,16.417-5.795,7.7292,1.1267,14.971-4.6683,17.708-13.361,8.2083-0.96583,8.6917-10.142,3.5417-16.259-4.8292-0.96584-1.125-17.225-18.675-14.005,7.4083,4.5071,1.7708,13.522,7.8917,17.708-4.1875,0-9.5792,1.7708-10.867,8.0488,1.6083-4.3462-0.24167-7.2438-1.3708-8.2096,0.1625-3.7025-8.0458-12.798-15.775-9.4979,5.5542,1.2075,2.4167,10.142,6.4417,13.522-2.9,0.16125-5.9583,1.61-7.7292,4.1854-2.0917-3.7025-9.4958-7.5658-14.004-7.8879,0-1.2879-0.24166-3.8633-0.80416-5.1512-2.0125-3.8633-3.7042-8.4508-2.9-14.327-3.8625,4.1854-7.0833,9.9808-9.0125,14.166-6.1167-4.1854-21.25,1.9317-28.333,3.5412-7.0833,1.61-30.908-2.2533-36.383-8.0488-5.4708-5.795-16.096-9.3367-26.075-12.234-13.725-3.9833-13.846-18.995-28.979-29.298-0.32083,18.674,28.013,77.914,34.45,84.353z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.54,426.32c11.913,0,21.571-9.6583,21.571-21.571s-9.6583-21.57-21.571-21.57-21.571,9.6575-21.571,21.57c0,11.913,9.6575,21.571,21.571,21.571z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370.02,409.74c4.3462,5.6346,11.751,5.3138,14.81,4.8304,2.5758,6.7583,10.785,6.6,14.327,10.3,3.5417,3.7042,15.613,3.3833,19.155,1.2875-3.2167-0.32083-7.4033-2.25-11.428-5.6333-4.8579-4.0792-2.5758-12.234-6.4392-15.131,2.8975-3.2196,3.3804-8.5317,2.7367-10.625,3.0588-1.7708,5.3121-4.6683,5.6342-6.1171,5.3129-0.32208,9.9796-3.0588,11.913-5.1512,2.7375,2.5754,9.6583-0.805,13.363,3.5412,0.80417-10.625-9.3375-16.259-16.1-12.717-2.7375-1.4488-9.9804-0.48292-11.268,1.4488-2.2538-0.96584-8.5321,2.2538-11.43,4.3462,3.2196-1.7704,3.7025-7.0829,2.4146-9.0146,2.7367-1.1267,5.7954-4.8292,6.1171-7.5658,3.8638,0.64375,9.6575-1.9321,12.233-1.2879-4.1833-5.4733-11.105-7.405-18.189-6.9221-7.325,0.40292-10.463,5.5542-11.429,11.108-4.3467,2.5754-5.7954,11.268-4.1854,14.327-2.4958-0.08-4.8296,2.3346-5.7954,3.7025-3.3804-1.4488-8.21-2.4946-11.671-2.4946"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.32,373.2c-1.4488-4.1854,0.47-7.9533,1.4488-11.268,2.495-8.4508,0.96584-10.625-6.6-9.4975-0.64375,4.0242,3.2196,17.225,5.1513,20.766z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.77,352.91c1.9317,1.9317,8.7738,2.8175,9.4979-3.2996,0.83167-7.0225-2.0121-9.74-8.1292-7.0033-0.48292,1.61-1.0471,8.21-1.3688,10.303z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.22,342.37c2.5758,1.0458,8.13,3.1388,11.188-2.8175,2.5658-4.9954-0.80458-8.8538-6.1167-8.5321-1.2883,1.4488-3.8638,6.6004-5.0717,11.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.97,330.54c0.64375,1.9317,7.2442,8.3708,12.073,3.7025,4.8296-4.6683,4.8296-11.59-2.4146-14.166-1.9321,0.32166-7.7271,7.0829-9.6588,10.463z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.62,320.08c1.4488,4.0242,5.9558,10.946,14.327,7.7267,8.3713-3.2196,4.8296-13.683,0.96625-15.776-2.2538,0.16125-11.43,4.3467-15.293,8.0492z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391.92,312.03c-0.64417,3.5417,0,13.2,11.429,13.039,11.428-0.16083,8.2113-13.522,5.3125-15.454-4.6683,0-12.556,0.16083-16.742,2.4146z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m409.14,310.09c-1.2879,2.7367-4.1896,20.75,18.191,15.776,2.8958-0.64375,10.463-17.225-18.191-15.776z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.37,311.7c-2.25,2.2533,3.5417,20.444,18.675,17.385,15.133-3.0588,2.4167-20.283-18.675-17.385z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.25,314.44c-2.4125,4.9904,1.2125,19.8,19.883,19.8,16.921,0-0.8875-19.478-19.883-19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.9,318.79c-1.2125,2.7662-2.6958,18.468,19.317,19.8,15.938,0.96583,12.075-21.571-19.317-19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m472.57,325.39c-2.7333,4.8296-5.6333,16.903,18.513,17.869,15.471,0.61917,5.9583-17.547-18.513-17.869z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.69,329.09c-3.5417,4.8296-0.93333,14.303,8.0458,16.098,11.271,2.2538,12.879-8.3708,5.1542-13.522-7.7292-5.1513-13.2-2.5758-13.2-2.5758z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m503.64,331.34c-2.575,4.5075-0.97917,15.454,16.096,15.454,3.5417,0,17.067-13.844-16.096-15.454z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.48,541.27c13.83,0,25.042-11.213,25.042-25.042,0-13.833-11.212-25.046-25.042-25.046-13.831,0-25.043,11.213-25.043,25.046,0,13.829,11.212,25.042,25.043,25.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m555.15,177.13c-1.9333,1.9317-5.9542,7.7267-6.7625,9.9804-8.3708,25.113,13.975,43.871,27.046,70.83,10.304,21.249,9.0167,54.733-7.0833,75.982-5.5083,7.2683-3.8625,9.3367-10.946,16.742-2.7167,2.8408-5.7958,6.4392-4.8292,16.742,4.5083-1.61,10.946,2.5758,12.233,6.1171,3.2208-1.6096,7.7292-0.96584,9.3375,0.96583,5.4708-2.5754,9.9792-1.2879,14.808,3.8638,4.1875-0.64416,8.6958,0,12.879,4.5071,2.2542-4.5071,6.7625-6.1171,9.9792-5.1512-0.32083-5.795,5.475-9.9804,10.625-7.7267-1.6083-7.7271,5.475-13.523,12.238-11.269,5.7917-4.5075,17.383-4.8292,23.179,1.9317-10.304-2.8975-9.9792,8.0492-18.675,7.0833,2.2542,6.4392-3.5417,10.142-9.3334,12.234,3.7-1.7708,7.725-3.8633,9.0125-1.6096,3.2208-2.8167,9.6584-1.7708,11.271-0.32208,4.2625-1.3679,8.3708-0.32208,10.3,4.8292,5.7958,3.5417,9.6583,12.556,5.475,19.318-1.2875-7.0829-6.1167-6.7613-8.05-9.6588-4.5083,1.61-9.0167,1.61-10.304-1.2879-2.575,2.5758-11.267,4.8296-15.129,0.96584-1.45,5.7954-6.4417,10.625-12.238,10.625,1.6125,4.5071-2.8958,12.236-6.4375,16.098,5.475,2.8958,3.8625,9.3375,2.575,13.2,8.3708,1.2875,1.2875,8.6917,15.775,13.521-7.0792,2.2542-20.925,0-22.858-8.6917-7.0833-0.32083-11.913-7.4042-11.588-14.813-5.475-5.15-6.2792-12.554,1.2875-17.705-6.4417,1.9317-9.9834-8.3708-19.321-4.1854-4.6417,2.0825-16.9-1.4488-16.738-5.7954-1.9333,3.2196-13.683,1.9321-15.296-3.5412-3.8625,2.0925-12.879-1.4488-12.717-6.7613-4.9917,2.2538-11.75-1.7708-11.429-6.9221-4.6667-0.64375-5.15-4.8292-4.8292-8.3708-4.1875-1.9317-3.0583-5.9563-1.45-10.785-2.8958-3.2196-1.6083-7.7271,0.64583-11.913-3.2208-3.2196-2.575-7.0829-1.6125-11.59-15.454-1.2879-34.813-5.015-79.2-18.673-66.967-20.605-84.997,27.688-70.187,57.952,17.087,34.919-1.9317,42.5,3.8638,68.579,6.1171,1.2875,9.3367,6.4375,9.015,11.913,3.6208,0.15834,6.1967,3.5375,4.9088,9.9792,3.0588-0.5625,7.0034,0.32083,9.5788,2.8958,2.2538-4.1833,9.6588-5.15,13.523-0.32084,8.3688-0.64583,12.556,6.1167,12.235,14.488,4.5042,8.05,2.8958,17.871-1.9333,24.146,0.48334-3.3792,0-8.2084-0.15833-11.104-0.3-5.3292-7.7292-6.4417-6.9242-10.788-3.8633,0.32083-7.5663-1.7708-8.8538-4.6667-2.2538,1.9292-5.4733,2.575-8.21,1.6083,4.3462,1.9333,7.7271,9.6583,6.4392,14.808,2.2538,3.8667,1.7708,10.95-0.96583,14.008-1.2879,6.275-6.1171,8.5292-12.395,5.7917,3.5417-2.25,4.8292-6.275,4.6683-9.6583-2.2538-1.9292-3.3804-5.6333-3.5417-7.8875-6.2779,0.96667-14.971-4.3458-16.574-6.4458-13.831,0-25.043,11.213-25.043,25.046-0.64375-5.1542-7.1588-10.229-6.3542-14.575-3.8633-11.913,1.61-23.021,17.386-25.271-1.9317-4.5083,4.8292-9.1792,2.2538-14.329-3.2904-6.5792-9.3367-15.133-18.351-25.113,5.4733-9.3375,3.8633-21.892,0.64375-29.62-4.6233-11.096-9.015-8.3708-25.435,9.6579-26.76,29.383-62.46,21.25-94.012,40.567-8.3838,5.1333-16.741,7.0833-7.7267-1.9292,9.015-9.0167,32.84-18.029,48.293-25.758,28.94-14.471,53.445-38.635,63.104-85.64,22.697-110.46,106.24-74.05,159.04-53.445,49.571,19.346,40.567-24.469,15.454-50.869-30.183-31.732-24.146-56.664-9.9792-76.626,25.433-3.5412,74.213,5.3125,64.392,13.845z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m644.82,448.48c15.217,0,27.554-12.333,27.554-27.55,0-15.218-12.338-27.554-27.554-27.554-15.217,0-27.554,12.336-27.554,27.554,0,15.217,12.338,27.55,27.554,27.55z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m539.7,178.41c-6.1167,27.045-0.96667,39.279,8.05,51.191,18.629,24.621,33.483,80.811,12.233,117.51"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m571.89,315.41c2.575-0.96583,7.4042-4.0242,8.5333-9.3367"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m573.82,303.66c0.80417-4.6683,8.0458-6.68,8.2083-11.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m573.98,285.46c-0.48334-4.8296,7.2458-9.1758,6.1167-14.005"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m569.8,268.08c-0.64584-2.7367,6.4375-7.8879,4.5083-12.234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m564.49,251.18c-1.45-3.0588,3.3792-6.6004,1.2875-9.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m556.76,237.65c-0.48334-2.0925,2.4958-6.68,0.8875-9.4163"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m549.03,221.72c0.64167-0.805,3.2208-2.7367,2.1708-5.1513"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m543.72,210.05c1.0458-0.56375,4.1833-1.53,3.7833-3.8633"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m382.58,513.57c-6.4392-2.2542-14.488,0.96667-16.098,6.4417"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m371.31,525c0.805-5.4708,9.1758-7.8875,11.751-5.3125-5.3121-2.8958-7.8879,7.4042-3.2196,7.7292"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m423.15,397.67c-3.8625,1.9321-4.9875,9.015,0,14.329"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m428.94,399.28c-2.7333,2.2538-2.575,9.0146,1.45,10.625-3.3792-2.4146,0-6.6,2.4167-6.7612,2.4125-0.16084,4.0208,2.7367,1.125,5.6342"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m655.12,415.21c-9.0125-2.4125-16.258,8.05-8.05,17.388-0.15833-9.0167,6.2792-14.971,14.167-13.363"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m657.61,425.47c-2.2167,0-3.4625,1.7333-3.4625,3.4208,0,1.7708,1.5292,3.4625,4.025,3.4625,1.6125,0,2.9-1.85,2.9-3.3"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m689.4,227.83c1.45,5.4733,9.0167,7.7271,14.971,6.4392"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m704.37,230.73c-4.6667,0.16125-8.5292-4.1854-8.2083-7.8879,0,2.7367,6.2792,4.0246,8.2083,2.2538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.83,414.57c-1.2875-3.2208,3.8638-6.4404,4.0246-9.4992,0.16125-3.0583,5.795-5.4729,11.59,0.32209"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m397.71,371.11c-1.1267,0.48292-2.0929,1.1267-3.0588,1.4488"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.82,388.65c-1.3688,0.0813-4.1854-0.08-5.715-1.1271"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.19,394.77c-1.1267,0.56417-3.6229,1.53-5.0717,1.8521"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347.97,492c-0.16125,2.9,2.7367,7.0833,4.3462,8.3708"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.53,485.08c-1.61,2.4125-2.5754,6.6-1.61,9.4958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.51,494.74c-2.8979-1.9333-0.96583-6.925-1.2879-10.142-0.32208-3.2208,3.3808-8.3708,10.625-4.025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.47,476.39c2.8979-0.48333,5.9563-0.325,7.8879,0.47917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m394.17,467.21c-1.2875,1.7708-1.6096,3.7042-1.7704,4.9917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407.69,466.89c-2.2538,0-4.1854,1.6083-5.1513,3.2208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.46,384.47c2.5758,0.88584,9.2558,4.9904,9.4979,9.2567"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.83,363.54c-7.8875-0.16125-10.946-8.21-4.99-8.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m418,374.32c-3.0583,1.2879-1.6083,6.6,2.7375,9.1758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m399.16,424.87c-1.5296-1.9292,0.48291-7.5625,5.4733-5.875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410.91,483.63c0.32-4.9083,6.52-7.8083,9.0158-2.2542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.05,497.63c-0.40292-5.3917,2.3338-7.1625,4.7483-7.4833,2.4146-0.32084,5.8767,1.6875,7.4863,5.2292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.08,501.66c0.32208-3.2208,3.0588-6.6,5.9562-6.1167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m634.67,358.71c-2.0958,1.53-3.4625,8.3708,4.5042,9.015"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m622.44,369.98c0,0.80459,1.0458,1.9317,1.6917,2.4146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m660.43,382.86c-2.0917-1.6096-7.4875,4.9104-2.575,9.6588"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609.24,436.95c-1.2083-4.5875,3.0583-5.7958,7.0833-4.8292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m598.94,404.43c2.4125-1.6096,4.8292-3.3804,7.8875-4.1854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597.65,422.13c0-3.8625,1.9292-7.0792,3.7-8.0458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m611.81,377.71c-0.32083,4.6683,1.6125,9.1758,3.0625,11.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m650.13,378.03c-2.3375,0.725-4.4292,1.6096-5.3125,3.5417"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m647.55,391.23c1.1292-0.96583,2.4167-2.0925,2.9792-2.8975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m708.4,250.69c0,4.5071-5.6333,6.9217-9.3333,4.0242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m720.64,250.85c2.4917,1.9317,11.104,0.0812,9.0917-4.9092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m710.17,276.77c-1.7708-0.32209-4.8292-2.2538-6.1167-3.8633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m727.88,263.41c-2.8958,0.64375-4.8292,0-6.2792-0.64375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m682.16,279.51c1.6083,0,5.4708-0.64417,8.1292-2.0117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m677.33,251.02c-2.0917-0.24083-3.625,0.16125-4.8292,0.96584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m709.77,258.9c-0.5625,2.0129-2.0125,5.1512-3.7833,6.5204"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m671.86,265.99c4.025-1.7708,9.0167,11.912,18.675,7.0829"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m691.34,258.9c-1.2875,1.7708-2.0917,4.5075-2.2542,6.9221"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m498.81,237.98c1.2875-0.16083,3.5417-0.64375,4.025-2.2538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.16,387.85c4.8296,2.7367,8.2104,7.405,6.1175,14.327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m554.5,223.17c1.45,0.96583,6.925,0.96583,9.9833-0.16083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m568.35,226.39c-0.1625,2.2538,0.48333,10.785-3.8625,12.556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m566.1,237.82c4.025,1.2879,12.075,0.80459,14.65-6.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m575.11,237.49c2.0917,3.2196,2.7333,9.4979-3.5417,12.878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m576.72,242.81c4.6667,1.6096,15.454,1.7704,14.325-7.405"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m587.35,242.81c3.2208,4.5071,17.388,9.8196,15.133,0.48292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m574.31,255.84c5.4708,1.2879,13.2-2.415,9.9792-12.073"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m599.74,248.6c0.80416,3.7025,18.833,7.5658,16.421-0.805"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m612.78,252.63c3.3833,7.7267,21.25,7.0829,15.617-3.2196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m625.5,257.45c3.5417,4.3467,19.321,1.7708,13.042-8.6929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m638.37,257.29c9.8208,7.405,21.25-3.2196,8.8542-10.947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m652.86,254.88c8.6958,6.9221,19.321-5.6346,11.754-9.1758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m584.12,251.98c2.7375,0.805,8.5333,0.48292,9.8208-4.5071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m591.77,250.85c-0.32083,7.325,11.996,10.142,15.133,1.6908"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m602.8,257.13c2.2542,4.8292,13.038,6.7608,14.808-0.16125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m615.84,260.19c1.7708,4.8296,11.108,4.3467,13.683-0.64375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m626.14,262.77c2.8958,6.2779,14.808,6.2779,17.546-2.8979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m641.6,263.89c4.6667,2.8979,14.65,1.7708,13.842-7.2438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m653.51,263.09c6.9208,5.6346,16.742,0.16125,11.913-9.3367"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m664.94,270.49c3.7042-0.64375,5.6333-8.0488,1.7708-9.9804"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m579.14,271.78c7.725-4.1854,9.175-11.268,3.8625-18.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m585.74,264.7c4.8292,2.8975,14.004-0.16083,15.613-7.2442"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m592.34,265.5c2.7333,3.5413,3.2167,7.8879-0.325,11.912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m594.59,270.01c8.5292-5.3121,19.154,4.5075,11.267,10.464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m604.41,269.53c1.9333-0.48291,5.3125-4.0242,5.6333-8.0488"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m608.27,273.23c3.5417-3.7025,27.692,3.8638,12.396,11.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m619.54,263.09c4.6667,1.7708,7.0833,8.3713,0,10.625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m625.66,279.19c5.15-5.3121,21.25-1.9317,15.454,4.8296"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m637.25,277.09c2.8958-9.82,20.121-3.7025,14.488,0.32167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m633.71,267.27c0.48333,1.9321,0.64166,6.7613-2.575,9.3371"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m648.2,265.34c0.64167,1.61,0.48334,4.6683-0.96667,6.6004"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m659.14,265.5c0.96666,1.7704,2.575,5.1513-0.96667,7.8879"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m521.35,191.45c0.15833,9.1754,3.3792,15.293,15.775,9.4975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.21,202.4c-6.1167,8.21,0.80417,17.064,12.879,8.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.37,206.42c8.3708,9.0146,23.342,2.4146,13.683-11.269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m530.2,214.15c-1.6125,8.8538,5.6333,10.625,11.588,6.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m498.97,207.87c1.525,8.9013,10.625,15.937,19.479,10.464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m509.92,220.11c0,12.718,17.546,14.166,21.571,0.96625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.21,229.12c5.6333,11.59,17.867,6.9221,21.892-0.16084"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512.81,210.61c2.2542,5.6342,6.7625,11.913,17.225,7.2442"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m480.62,207.87c1.45,4.6683,9.8208,10.303,19.479,3.8633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486.57,213.83c-5.1542,7.5658,5.15,14.649,17.546,3.3804"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.69,223.17c2.0917,10.625,6.275,19.157,21.408,5.4733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.53,234.11c5.475,6.7608,13.846,10.946,21.733-0.48292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m534.06,236.04c-0.48333,8.0488,1.125,12.073,7.4042,11.751,4.95-0.25334,9.6584-4.1854,12.396-8.3708"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m540.34,247.8c-0.1625,9.1758,7.0792,16.42,20.604,7.0833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m545.97,258.58c-2.575,6.9221,5.15,18.19,20.283,12.395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m513.94,240.23c-0.9625,8.8538,7.2458,14.81,20.446,3.3804"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m520.38,250.05c0.48334,7.2442,8.6917,15.937,20.767,3.3804"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.17,259.23c-0.96667,12.395,10.463,15.937,20.121,6.4392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m508.95,250.05c2.575,0.16125,4.6667-2.0925,5.9542-3.7025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m514.42,259.06c2.2542,0.48292,6.1208-1.61,7.4083-4.1854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m520.06,273.71c2.575,2.7367,11.267,0.805,12.392-2.8975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m529.72,273.55c4.8292,11.268,17.704,10.785,23.017-1.9317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m550.32,276.13c2.4125,6.6,8.5333,10.785,18.513,8.5317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m555.15,282.89c-5.6333,9.1758,1.7708,19.961,14.325,9.3367"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m558.21,296.57c-0.64167,5.795,4.6708,12.395,11.913,13.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m534.38,279.67c-1.9333,13.039,7.4042,19.318,19.158,12.395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m520.7,285.95c3.0583,2.4146,8.5333,2.7367,13.683,0.805"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m540.66,294.32c-2.9,10.947,8.3708,18.835,18.029,6.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.05,287.72c0.1625,5.6342,5.6375,11.751,15.133,9.9804"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m566.74,308.97c-6.4417,4.3462-7.7292,12.073,1.2875,17.063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m550.96,306.71c0.325,6.6,3.3833,10.303,10.625,10.946"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m541.47,303.33c-9.6583,8.8542-0.1625,19.157,11.267,10.464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m548.23,316.53c-3.2208,10.142,8.8542,16.259,15.292,5.9562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.27,294.96c-3.5417,9.9808,0.96667,16.581,9.175,15.937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m515.55,293.03c0.48334,5.9562,5.6333,8.0488,11.429,6.7612"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m519.25,299.31c-4.3458,8.3708,2.2542,12.878,10.95,9.6588"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m556.6,327.64c-1.45,5.3121-0.64583,9.1758,7.2417,10.947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m557.08,335.21c-9.5,4.3467-10.304,13.523-2.9,19.478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m549.43,324.99c-4.9875,4.5075-4.025,12.314,1.45,15.373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m507.18,295.61c-5.475,5.3933-0.24167,20.283,11.829,12.155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m538.57,314.44c-7.4083,6.1175-4.025,17.225,8.2083,14.166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.33,309.77c-3.8625,10.947-0.15834,14.81,8.5333,14.971"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m499.13,295.12c-6.6,4.99-4.8292,12.073-1.9292,15.293,2.8958,3.2196,8.3667,1.7708,10.138-2.4146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m485.28,290.78c-7.4042,9.4979,0,20.766,10.467,17.386"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m524.89,318.95c-7.5667,2.7367-13.338,9.6071-8.6958,15.615,2.7375,3.5417,14.65,4.0246,18.029-9.6588"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m511.2,310.09c-4.3458,6.2783-2.9,12.235,5.15,15.293"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510.72,321.85c-4.6708,2.5758-7.7292,5.6346-6.6,11.269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m500.26,312.03c-1.7708,7.5663,0.32083,12.235,4.9875,14.488"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m500.1,321.04c-7.2458-0.48292-10.946,2.5754-8.5333,9.6588"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.21,322.81c-7.0833-2.5758-8.2125-8.6929-5.1542-15.132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486.09,317.18c-7.7292,0.32208-11.108,4.1854-11.108,9.4979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m475.62,287.07c-5.6333,2.4146-7.4042,9.9808-5.3125,14.166,2.0958,4.1854,8.6958,4.5075,12.721,1.7708"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m459.85,281.12c-5.15,5.7954,0.80417,17.064,9.9834,14.327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m446.65,276.61c-4.8292,6.7608,0.48333,18.03,12.879,14.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m460.17,322.81c-1.2875-8.0492,7.0833-13.361,17.388-2.8979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m472.57,303.66c-3.0583,2.7367-4.5042,7.0829-4.025,10.625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m433.45,272.75c-5.3125,9.015,1.1292,17.225,12.558,14.005"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m463.23,295.12c-7.5667,7.5658-4.9917,15.132,0.64167,19.478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m458.4,303.98c-11.429,0.16084-12.071,13.361-2.7333,17.547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449.71,290.78c-4.6667,3.2196-6.1167,12.073,1.9333,15.615"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449.39,310.58c-4.8292-2.2538-10.625,0.48292-10.142,6.1171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m442.14,310.74c-4.3458-10.303-17.063-8.5317-15.933,2.0929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.68,298.02c-2.7333,0.48291-8.2083,2.0925-10.3,6.2783"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m436.19,286.43c-5.15,5.795-1.1292,12.717,3.0583,14.166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m420.9,270.17c-0.96667,6.9221,1.7708,10.303,10.463,9.6588"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.95,279.03c-3.3833,8.3708,1.125,12.073,9.8167,11.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.88,289.33c-5.15,6.1171-1.6083,12.718,3.3792,15.454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.47,297.06c-9.175-1.1271-10.625,9.4975-7.5667,14.488"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.06,269.37c-5.6321,2.4146-8.8517,9.4975-5.7933,13.844,3.06,4.3463,9.1767,2.8975,12.556,0.64375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m412.2,285.14c-4.6675,7.0829-0.48333,12.395,4.5083,14.488"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m394.17,268.56c-3.7021,3.8633-1.4488,11.752,7.5663,11.913,7.2579,0.13,10.946-6.7612,8.6929-11.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400.45,280.47c-2.8975,6.4392-1.1267,13.361,9.8196,12.234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.94,302.85c-6.7608-3.0583-15.776,0-11.912,8.0492"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.06,291.42c-2.7367,3.8633-1.7708,9.3367,1.2875,12.717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401.58,301.72c-4.5075,0.805-8.8542,3.2196-6.1175,10.303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m394.81,306.23c-5.795-1.7708-13.2,2.4146-8.6929,8.3708"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m385.16,308.97c-4.9904-0.80501-10.946,4.5071-6.1171,9.8196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.11,314.44c-4.5075,1.1271-9.8196,6.2783-5.1517,10.303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m399.81,289.17c-6.4392,2.8975-7.0833,10.142-4.0246,15.454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m393.04,275.81c-9.6588,3.7025-9.4975,16.581,1.1267,20.605"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m389.66,293.51c-5.795,3.3804-6.9221,9.8196-3.0583,14.005"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379.52,270.98c-3.8638,1.2879-3.5417,13.2,6.7613,12.878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368.9,275c-7.7271,5.1513,1.6096,18.19,14.166,8.8538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.14,287.07c-1.1267,5.3125,0.32209,11.108,8.8542,11.752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.62,294.16c-6.1175,2.2533-7.2442,14.81,3.8633,15.776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.15,282.73c-7.8879,7.2442,6.4392,13.522,11.752,3.0588"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.2,294.8c-3.8638,4.6683,9.6583,16.903,15.615-3.5417"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m363.26,290.94c0.32167,4.8292,3.2196,7.7267,9.1754,8.0488"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.28,303.66c-9.4975,1.4488-12.556,13.361-1.9317,15.937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m354.73,302.05c-0.32208,4.5071,4.3463,8.2096,9.6588,7.405"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.22,319.27c-8.6925,1.9317-9.8196,13.2-2.0925,12.556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m363.1,342.29c-7.2446-2.1729-7.4054-10.786-0.96625-14.005"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.15,334.72c-6.1167,3.7025-3.7021,12.556-0.48292,13.844,3.2196,1.2879,5.7954-0.32166,6.1175-3.0583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.3,357.9c0.64417,4.1854-14.891,2.5758-6.9217-10.463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m355.29,358.63c-5.2313,8.21,3.3008,14.89,8.6929,7.8883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.02,368.53c-2.0929,6.6004,5.875,11.35,11.026,6.1983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.63,306.71c-2.8979,5.9563,11.59,8.2096,12.556-4.0246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.61,315.57c-2.8975,11.59,18.995,9.1758,13.361-5.7954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.45,317.5c3.0583,1.7708,12.235,1.9317,14.488-7.8879"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.34,317.82c0.64375,3.0583,3.3804,6.7608,5.9558,7.8879"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m345.88,320.88c-0.96583,6.2783,5.3121,11.43,12.556,10.947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347,327c-3.5412,4.8296-4.6683,14.166,6.4396,14.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.1,328.61c-1.7708,4.9904,8.6929,10.142,14.81,1.9317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.88,341.32c-0.88625,3.7838,8.5317,8.8542,13.844-7.2438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.54,342.29c2.2538,4.0242,9.8196,7.2438,14.488-0.64417"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m343.46,346.48c-1.9317,5.6342,3.3808,10.946,9.8196,9.3367"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331.39,345.19c-1.2879,8.0488,8.0488,12.717,13.844,8.5317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m325.27,348.73c-2.7362,10.303,10.464,14.166,15.454,6.4388"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.35,358.23c0.48333,5.7954,9.4983,10.785,16.581,5.9563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m321.25,363.06c-0.64375,2.5754,10.142,5.1513,11.751-3.8638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.53,365.31c2.5754,6.6004,11.268,8.21,16.259,0.16125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.89,368.69c1.1271,6.1171,9.015,9.4975,15.937,5.3121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.72,376.42c-1.7704,8.21,6.7613,14.81,12.073,10.303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.04,374.97c-2.5754,9.015,8.6929,14.166,14.971,9.1758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.52,370.46c-0.64375,8.3708,5.9562,13.361,13.522,9.6583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m318.19,371.27c-2.2542,5.4733,9.6588,9.9808,15.293,5.3125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310.78,386.24c3.0588,3.5412,13.683,0,14.649-7.8879"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.54,384.14c3.8633,4.5075,13.039,6.9221,16.742-2.7367"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.06,386.4c-0.16125,6.9221,12.235,11.913,16.259-0.805"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.88,388.09c-1.1271,3.3808,1.53,8.7729,7.0829,9.4167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.66,386c-0.805,3.8633,4.8296,9.2554,10.786,7.0829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368.58,394.69c-1.6096,4.1854-0.24208,10.221,5.3921,10.141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.14,402.5c-4.1854,3.5412-2.415,9.8204,3.6229,10.062"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.97,408.45c-5.9563,4.0225-3.8633,12.877,4.0242,12.398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.94,391.39c0,8.6929,10.785,9.9804,12.878,1.9317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.63,398.47c-1.61,5.1512,2.5754,10.142,9.1754,8.6929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.92,460.61c1.4492,2.0958,7.405-1.4458,5.7954-4.9875s-7.9192-1.6167-7.2442,2.0917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m363.26,454.17c0.80459-7.0833-7.5663-8.2083-9.6588-2.0917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.66,448.54c2.0929-3.5417-4.99-8.3708-7.8879-3.2208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351.35,443.22c1.9317-5.1542-6.1171-7.4042-6.7613-2.7375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m342.82,433.72c0.96625-2.575,9.9808-0.96667,6.1175,4.3458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m355.86,444.51c3.5417-3.2208-2.4142-9.8208-6.1171-7.4042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379.68,454.33c-2.8179,0.32084-5.7158,2.1708-3.6229,8.1292,1.4512,4.1333,7.6471,4.3458,8.5317,1.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m375.58,457.31c-2.7367-1.7708-8.6929,1.2083-5.9562,7.0042,2.0604,4.3625,7.2442,2.575,8.0488,0.32083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.2,465.6c1.3675,2.4125,8.2088,1.3708,9.4167-1.2875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364.87,457.63c1.4488-0.96667,4.1042,0.2375,4.6683,1.4458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364.39,417.95c-4.6683,3.0583-1.7708,12.396,5.4733,9.9792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.94,425.52c-3.7025,2.8958-0.32208,11.913,6.6,8.5333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364.07,434.05c-2.5754,2.575-0.0808,9.7375,6.6004,8.3708"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m363.1,437.59c-1.4492-0.64584-5.2325-0.1625-6.8425,2.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.92,404.99c-3.5412,3.3804-1.8517,10.304,4.7483,10.866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.63,412.07c-5.0717,2.4958-5.0717,12.554,5.07,12.958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.23,423.42c-2.8167,2.2542-1.4488,10.946,5.7954,9.8167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.56,432.92c-1.0471,1.0458-1.2083,3.7042-0.32208,4.8292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.34,429.62c-2.5754,0.0792-5.9562,1.9333-6.8425,4.5875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.83,424.87c0.96583-2.575,8.9354-2.4125,9.4979,5.1542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m355.13,421.01c-1.1271,0.24167-3.2996,1.2875-3.8633,3.4625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351.67,397.43c-3.4617,3.1388-5.1512,13.04,5.3921,14.97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.67,417.87c0-2.6583,7.1642-4.9125,9.6588-0.96666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.08,403.46c1.0458,2.0129,6.0362,4.7496,9.095,2.4958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.16,387.69c-0.16042,4.6683,3.7029,8.8538,9.015,8.21,5.3121-0.64417,6.4392-5.3125,4.8292-8.3713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.98,396.06c-3.5417,4.3463,0.805,10.464,4.8292,8.6929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.01,393c2.0929-0.805,9.015-1.7708,11.108,1.4488"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.63,394.29c-1.61,2.4146,8.3712,4.8296,11.751,0.16083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314,396.86c-0.3225,3.2196,1.2875,8.6925,9.4975,6.4392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.79,408.29c1.2875-2.7367-4.8296-7.2438-9.4979-2.2538-4.6683,4.9904,0.64375,10.625,3.5417,8.6917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m303.38,397.51c-2.4146,4.1854,6.9221,11.833,12.235,4.7496"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.18,404.75c-3.3804,3.4617,0.805,9.8208,5.8763,7.8875,5.0704-1.9313,4.5875-7.2438,3.3808-8.6113"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.66,411.19c-2.7367,2.4942-0.0813,8.3692,3.7025,8.3692,3.7821,0,6.1171-2.975,5.3921-6.7583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.03,410.71c-0.48333,3.7021,4.99,6.2771,8.5317,2.8188"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.73,406.76c0.48292-0.805,0.0813-2.1742-0.72334-2.8179"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.79,416.18c-3.1383,2.4958,3.6229,9.4167,7.8879,3.0583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m309.01,414.81c-2.0129,1.9292,1.2067,7,4.4262,5.4708"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.99,418.35c0.48292,3.4583,7.2442,6.0333,11.51,0.725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.69,421.81c-1.0458,2.175,1.0471,5.6375,3.6225,5.1542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.76,441.7c-2.4942,4.9083,5.4733,10.625,11.269,4.6667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.55,449.02c-1.2067,2.6542,0.24209,6.3583,2.4146,7.725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m363.99,454.57c0.56417-2.4167,4.0242-4.6708,7.1642-3.5417"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.8,448.21c0.48292-2.1708,3.3804-4.3458,5.5542-3.7792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m549.35,347.76c-11.429,0.16125-6.6,18.513,3.2208,14.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m545.65,361.29c-2.2542,3.7025,2.0917,9.5788,6.9208,6.1171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m551.29,368.13c-3.3833,5.6342,8.6917,14.246,13.521,5.3921"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m560.95,376.9c0.15834,5.3125,15.613,8.6929,13.363-1.9317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m572.86,380.76c3.7,6.2779,17.546,6.9221,16.096-2.4146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m585.9,384.79c2.9,4.1854,16.421,6.7608,15.938-1.9321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m531,331.83c1.9292,4.9904,8.5292,6.7613,15.775,3.8633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.82,335.37c4.5083,2.8975-2.0917,16.098-9.0125,10.785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.82,343.58c4.9917,2.415,11.108,0.64417,12.879-6.4392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m536.64,342.61c0.48334,3.7025,5.7958,6.6004,12.717,5.1512"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m524.24,346.48c6.4417,5.4733-2.8958,16.742-7.0833,11.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.66,350.66c3.0583,2.2538,10.946,0.96584,11.75-4.9904"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m534.87,350.66c0.64583,3.8633,3.7042,5.3121,8.05,5.4733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m524.89,355.97c3.2167,4.5075,11.267,5.7954,14.808-0.16083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m536.15,359.19c-0.32083,4.3467,4.5083,7.8879,9.5,6.9221"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m518.61,368.85c4.1833,2.0925,8.6917-5.795,5.15-11.268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m523.44,377.22c4.9917,0.32208,5.6333-7.2438,0.96667-11.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m534.87,384.14c4.1875-0.96583,2.8958-10.142-7.2458-10.947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m547.58,390.91c4.025-1.1271,0.80417-11.269-10.3-10.625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m562.88,394.45c2.7333-4.1854-6.2792-11.268-13.683-7.5658"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m570.44,400.24c4.9917,1.4488,8.3708-11.751-7.4042-9.6588"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m579.62,400.24c4.35-1.1267,7.4084-9.015-5.3083-6.4392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m589.28,400.89c3.8625,1.9321,5.6333-9.3367-6.1208-6.2779"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m524.4,365.79c4.8292,2.7367,12.396-0.48291,11.75-6.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m534.22,364.51c1.6125,2.8975,0.96667,8.5317-2.0917,9.9804"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m534.7,371.27c3.2208,1.2879,7.5667,0.16125,10.142-4.99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m540.34,371.27c0.9625,2.2538,1.2875,6.7613-0.80833,9.015"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m541.15,375.13c3.5417,1.9317,7.725-0.64417,9.4958-4.3467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m548.39,374c2.575,1.61,4.8292,9.1758,0.48333,12.235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m551.29,382.7c3.0583,0.16083,7.5667,0.16083,10.463-3.7025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m559.66,381.09c2.7375,0.805,5.9542,5.3125,4.8292,9.3371"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m564.65,388.97c3.0625-0.32209,8.3708-2.415,9.8208-6.1175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m573.02,385.27c2.5792,1.4488,4.35,4.5071,4.025,8.0488"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m577.04,390.74c3.0583-0.16084,5.7958-1.7704,6.6-5.1513"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m582.84,387.85c2.2542,0.805,4.9917,3.3804,5.1542,6.4392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m587.67,392.35c2.2542-0.32209,3.8625-1.7708,5.3125-4.0246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m599.1,388.01c2.9,2.8979-0.9625,12.557-6.9208,10.786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m537.28,192.9c-5.9583,3.5412-22.863,2.4146-14.492-11.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m538.89,183.4c-11.75,4.6683-26.242-4.3462-11.108-14.166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m523.76,166.02c-9.8208,0-16.421,15.776-3.2167,21.249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m485.61,172.62c-2.575,4.99,6.6,10.463,12.879,5.4733,4.8625-3.8662,4.5042-14.327,1.6083-18.352"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m480.62,184.53c-3.2208,10.624,20.446,11.268,16.742-5.6346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.33,200.31c0.80417,8.0488,22.7,5.4733,15.613-10.786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m497.52,185.01c1.7708,2.4146,6.6,6.6,14.808,5.795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m501.38,173.58c0.725,2.8975,5.6333,5.1512,11.913,2.9788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.73,418.51c-5.5533,3.9458,2.9788,10.142,6.1171,3.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.38,421.57c-5.5529,3.9417,2.9788,10.138,6.1175,3.2958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.79,424.55c-5.5546,3.9458,2.9775,10.142,6.1171,3.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.96,427.29c-5.3125,2.8167,0.88458,9.7375,6.2779,3.6208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.73,429.95c-5.3125,2.8125,0.88584,9.7375,6.2783,3.6208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289.7,421.65c-0.0813,4.1042,7.7271,5.7958,10.543-0.325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m294.61,425.44c-2.4146,3.0583,2.0129,6.8417,4.4275,5.4708"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.22,424.87c-0.24208,3.4625,6.5188,5.475,9.8196,1.6917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.93,428.5c-2.1738,2.8167,2.0925,6.6,4.8292,5.4708"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279.72,428.01c0.24083,2.7375,4.1042,5.875,8.29,4.1042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.21,431.71c-1.61,1.45-0.80459,4.8333,1.4488,5.8792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.84,431.47c-0.64375,2.4958,3.6225,6.925,7.9688,4.025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.72,434.37c-2.5754,2.0125-2.2538,5.0708,1.0458,5.4708"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.53,434.05c-0.32167,1.6875,1.8521,4.425,4.5888,4.1042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.76,433.89c-2.5754,1.3667,4.0246,8.3708,8.1288,1.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.4,436.78c-3.2196,1.5333,4.7492,9.2584,8.2913,1.3708"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269.25,436.46c-2.4958,0.5625-4.1054,4.1875-2.0129,5.6333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.12,437.75c-0.32208,1.45,2.7367,3.8625,5.2329,2.9792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.03,438.4c-2.4146,1.5292-1.1271,5.7917,1.6908,5.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.42,441.21c-2.2538,1.6875-0.725,5.0708,2.4146,4.2667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.52,440.97c0.0813,0.88333,2.0929,2.2542,3.7838,1.6917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.61,439.52c-2.8162,1.2083-2.6554,8.2917,6.8425,4.4292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.25,442.34c-3.9446,1.9333-2.6567,7.2458,5.9562,2.175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.93,444.92c-1.0458,0.80416-2.1725,4.3458,1.7708,2.975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.69,446.6c-1.6096,1.45-0.5625,4.4292,2.9792,3.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227.4,447.09c-2.8975,1.6917,3.4604,3.9458,7.7271-0.5625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.33,449.18c-1.2883,1.2875-1.2883,5.0708,2.0925,3.7042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221.12,450.71c-1.9317,1.45,1.3679,3.3833,7.405,0.725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.53,452.8c-2.2538,1.85-2.0129,4.1833,1.2875,3.4583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216.85,453.85c-2.4946,2.2542,1.1267,3.7833,5.4733,1.9292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216.93,456.35c-4.2667,1.9292-2.415,5.4708,0.24084,4.1042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.4,468.66c-0.98917,2.1292,2.2538,3.8625,5.3125,3.3792,2.9379-0.4625,5.7483-2.8833,3.5413-6.275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368.41,469.95c2.8975,2.2542,8.0488-0.32083,8.0488-3.7042"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m545.97,128.83c-12.879-6.4392-39.6-18.352-47.167-8.6929,6.9208-2.8975,27.204,0.16125,43.946,15.615l3.2208-6.9221z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m553.78,128.15c-14.892-17.347-23.663-13.464-34.371-19.439-10.058-5.6142-26.079-6.7612-29.183,2.1671,14.696-7.1575,28.188,3.8488,36.475,5.1804,11.383,1.8279,17.808,10.628,21.138,14.675l5.9417-2.5833z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609.88,125.93c-7.7292-17.708-24.254-13.083-31.554-20.605-10.621-10.946-37.504-21.088-48.613-13.522,24.467-1.2879,34.888,16.865,47.971,23.181,9.3375,4.5075,19.317,14.166,32.196,10.947z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m580.91,124c-13.2-16.42-33.488-30.908-42.821-25.435,12.233,0.64375,16.096,9.1758,24.792,14.649,8.6917,5.4733,4.8292,13.361,18.029,10.786z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m518.12,152.98c-13.846-5.1513-40.888-7.7267-53.446,8.0492,20.929,3.5413,52.479,1.6096,53.446-8.0492z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m515.55,159.1c-13.846-6.4392-24.658,2.555-37.671,1.2875-24.788-2.4146-42.496-0.96584-44.75,10.947,14.167-12.717,37.992-2.2538,47.65-4.8292,9.6584-2.5758,45.396-0.32208,56.663,4.5071-5.7958-7.0829-14.808-9.0146-21.892-11.912z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m559.01,122.23c-3.2167-10.625-3.0583-21.893,12.879-21.088-4.025-4.9904-18.833-7.5658-21.25,11.108-17.546-12.878-36.704-15.132-40.242-4.0242,9.0125-7.7271,23.017-2.0929,39.758,16.903,1.45-0.805,5.3125-2.4146,8.8542-2.8975z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m534.87,136.88c-9.9792-6.4388-23.504-16.903,0.1625-21.088-10.142-5.4733-24.954-3.0588-23.342,15.615-27.046-10.947-46.467-7.2521-50.55,3.5413-4.5083,11.913,12.238,18.513,15.133,10.947-3.0583,1.2879-13.521-2.2538-8.05-9.015,5.475-6.7608,33.525-1.6854,60.208,12.235,7.4042,3.8633,32.838,3.2196,6.4375-12.235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.78,154.59c-7.7-15.722-32.679-1.4488-37.713-16.678-6.8792,22.312,35.521,9.9658,37.713,16.678z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m686.67,171.65c5.2375,2.6025,9.7667-1.4888,1.7542-4.6979,5.2417,2.6012,9.8125-1.3925,1.8-4.6029,5.2417,2.6012,9.8125-1.3921,1.8-4.6025-2.1375,2.1517-5.1958,10.04-5.3542,13.903z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m689.4,141.39c11.592-12.234-0.9625-16.42,13.2-28.976,11.592-10.273,2.2125-17.12,13.204-25.113,3.5417-2.5754,11.267-7.7267,11.913-12.878,4.6667,11.59-14.492,13.2-13.204,31.874,0.82084,11.89-7.2167,10.851-10.3,30.908-0.64583,4.1854-3.5417,13.522-14.813,4.1854z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m694.56,146.86c6.4375-13.844,13.829-13.578,17.383-18.995,6.7625-10.303,21.088,1.7708,33.163-7.405-2.0917,13.039-18.35,8.3708-25.433,16.742-7.0833,8.3708-12.879,12.235-25.113,9.6588z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m696.17,151.37c11.271-9.015,19.575-3.0008,27.367-7.7271,19.638-11.913,27.529,2.4146,45.075-3.2196-4.6708,11.268-30.588,1.61-41.854,9.9808-11.271,8.3708-50.871,16.42-30.588,0.96583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m663.33,215.6c-0.1625-5.1513-4.9917-11.752-11.754-12.556-6.7583-0.805-9.6583-7.8883-14.808-8.21-5.15-0.32209-8.5333-10.625-15.617-10.464-7.0833,0.16125-9.9792,9.3367,6.6,17.708,16.583,8.3713,34.933,18.03,35.579,13.523z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m642.4,219.95c-7.0833,0.32209-8.05,10.625-14.808,10.947,9.3334,4.9904,16.096-2.2538,20.925-8.6929l-6.1167-2.2538z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m648.2,221.23c-6.1167,5.1513-7.8875,15.937,0.96667,18.995-5.3125-7.3246,9.3375-10.625,4.8292-17.386l-5.7958-1.6096z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m654.31,221.56c-4.8292,9.3367,7.5667,10.463,4.3458,17.547,7.0833-1.61,8.2125-14.971,1.7708-18.513l-6.1167,0.96625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m606.98,201.59c11.592-0.64375,22.192,5.6267,29.3,15.776,4.5083,6.4388,19.638,9.0146,24.792,3.8633,5.15-5.1512,2.2542-16.098-10.625-12.556-3.2208-5.4733-12.558-3.5417-17.063-8.0492-4.5083-4.5071-21.896-17.385-26.404,0.96584z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m650.45,208.68c-3.0583,0.64375-4.025,5.9562-2.0958,8.6929"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m657.05,211.9c0.96667,1.6096,0.32083,3.8633-0.1625,4.9904"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m625.34,202.08c5.9542,0.32209,7.0833,4.6688,13.521,6.2783"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m621.4,187.43c20.571,5.1512,36.892,9.6588,47.013,15.454,10.121,5.7954,25.792,7.405,39.504,3.5417,13.713-3.8633,40.154-7.405,38.85,9.6588,7.1875-8.5321-1.9583-17.708-20.242-19.318,0.32916-8.3708-8.6292-15.937-15.071-10.947,5.9583-0.80459,11.1,10.303-0.65,14.81,2.2833-8.3708-6.0417-15.937-14.692-12.234,5.55,1.6096,11.163,10.917-1.2542,14.488-7.8375,2.2538-19.263-0.64375-27.75-5.795-8.4875-5.1517-56.154-23.825-45.708-9.6588z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m673.31,179.06c-6.4375,2.8975-2.2542,9.6588-12.233,13.522-9.9833,3.8633-16.904,12.717-14.65,20.283,6.7625-14.81,18.675-14.166,22.858-19.961,4.1875-5.7954,10.304-14.327,4.025-13.844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m675.08,180.02c-0.32083,11.751-9.5708,7.4704-5.9583,23.986,1.1292,5.1512,3.2208,13.522-0.32083,21.893,10.383-7.5658,3.7042-23.46,8.3708-29.459,2.2542-2.8975,5.15-7.405,6.2792-11.268-2.4167,6.7608-2.2542,19.318,4.3458,22.537-5.3125-12.557,14.329-22.859,0.80417-37.347-1.9292,3.5417-8.05,9.8196-13.521,9.6588z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m642.24,168.27c1.6125,2.4146,3.2208,8.5321,1.7708,11.913,3.2208-1.9317,7.8917-6.9221,9.3375-10.303,6.6,0.96584,9.175,9.1758,2.9,12.717,3.8625,0,10.463,0,14.163-4.3462-4.5042-4.9904-18.508-12.718-28.171-9.9808z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m542.11,145.18c-1.0417-0.94916-2.8-1.8517-5.9542-2.4996-9.7458-1.9988-4.7125-10.784,3.5833-10.706,17.704-19.317,27.646-4.4262,49.217-10.543,7.55-2.1404,12.733-1.5079,16.846,0.27167,9.6583-6.4392,20.988-4.64,29.2,2.9262,0.9125-1.4517,2.1375-2.5592,3.8583-3.0371,7.5625-2.1004,13.679,4.3479,15.771,12.719,5.8958-1.0921,12.629,1.8262,17.058,5.8504,6.1333-3.15,10.358-3.29,11.913-0.0512,5.475-2.5758,12.567-4.1908,16.108,4.5021,3.5417,8.6929-8.3708,6.1171-10.304,24.469-1.1917,11.321-13.842,15.776-23.825,9.015-15.967-10.817-31.55-12.557-39.279,3.8633-7.725,16.42-13.779,25.96-32.517,20.605-6.7583-1.9321-15.454,0.64375-20.925,8.0488-5.475,7.405-13.846,0.48291-23.825,1.2879,12.554-1.9317,7.7458-5.0896,18.675-5.7954,9.9792-0.64375,7.4042-9.9804,13.842-11.268-25.113,6.4392-24.146-2.8979-44.75,3.5412,9.0125-11.59,23.179-5.1513,30.263-11.912-18.675-0.32208-27.025-12.522-35.417-7.405-13.2,8.0488-7.4083,30.965-41.854,28.976-16.742-0.96583-27.367,1.2879-37.346,11.269,17.388-36.059,41.038-16.249,52.479-27.688,6.7625-6.7613,11.913-11.913,15.454-18.352,1.2458-2.2667,2.9333-3.5621,5.0417-4.0629-28.654-9.015-11.325-23.058,16.688-24.023z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m683.59,140.11c0.4375,0.90542,0.6625,2.08,0.6625,3.5325,0,7.0829-10.625,7.405-11.267,17.869-0.3375,5.4733-0.96666,8.5317-4.6708,7.8879-3.7-0.64417-6.9208-6.4392-3.3792-13.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m547.42,134.63c-2.6667-1.8738-5.3333-2.635-7.725-2.6571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m605.74,121.65c8.525,3.6908,12.683,12.546,25.067,12.98,11.921,0.41833,19.321,17.708,39.279,6.4388,0.54167-0.305,1.0708-0.58959,1.5833-0.85375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m635,124.63c-1.7792,2.8292-2.1833,6.7783-1.6958,10.244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m596.04,161.03c-15.129,0-18.996,7.7267-18.996,15.132,0,7.405,7.0833,17.064,19.642,17.064,12.554,0,19.317-7.7267,19.317-16.098s-7.7292-16.098-19.963-16.098z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m598.77,192.9c-0.32084-4.1854-7.8875-3.5417-7.5667-6.7613,0.32084-3.2196,4.1875-4.5075,4.1875-9.0146,0-4.5075,6.7583-4.8296,9.0125-1.2879,2.2542,3.5412,9.0167,10.463,10.467,6.9221"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m604.41,175.84c-3.5417,3.5412-5.15,10.785-0.48334,16.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609.24,181.31c-1.125,2.4146-1.4458,6.1171-0.15833,8.3708"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m669.36,169.48c11.833,0.96583,13.846-12.074,4.9917-12.878"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m654.8,134.31c-4.1042-5.2313-13.521-7.0021-13.683,4.1054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m639.99,151.05c-4.025-9.9808-14.329-11.43-19.804-6.4392-4.5542,4.1533-4.6667,14.971,5.1542,17.225,3.3792-4.0242,9.9792-9.3367,14.65-10.785z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m635.56,144.77c-5.7958-5.1517-14.329,4.5883-6.6,13.522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.31,169.16c3.8792-0.92083,9.55,0.9775,18.246,5.0675,5.475,2.5758,21.896,8.0492,32.196,2.5758-10.625,3.8633-18.671-12.235-26.721-10.303-8.05,1.9317-22.779,4.9096-28.975-0.96625,15.129,0.96625,23.267-11.021,40.563-0.64375,4.8333,2.8975,10.95,4.8296,16.421,4.5075-14.163-17.064-32.838-6.1175-34.771-19.961,8.5333,9.1758,29.379-2.0929,40.004,15.132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m545.33,152.01c-1.9917-2.4792-1.0917-4.9504-3.2292-6.9054"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "none",
    d: "m654.8,134.31c-3.5417-3.7829-11.267-0.805-9.0958,6.8421,1.6917-3.5413,5.3125-6.52,9.0958-6.8421z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "none",
    d: "m632.91,154.93c2.4375-1.7696,4.9542-3.2233,7.075-3.8817-1.1583-2.8642-2.8292-5.0262-4.7583-6.5346-1.8417-1.2721-7.1333,5.8442-2.3167,10.416z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m623.4,141.87c-5.7958-3.8633-11.108-3.5413-12.879-0.32167-4.1833-0.16125-7.6458,2.8975-7.8083,9.0146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m611.65,153.14c-6.9208-4.7483-16.421-2.9775-15.775,7.6471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m591.69,166.82c3.3792-2.7367,8.2083-4.6683,11.913,0.16125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m643.37,156.36c-1.2875,1.7704-2.2542,4.5071-0.1625,8.6929-2.575-3.3808-9.0125-3.3808-15.938,5.6338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m658.66,155.88c-8.3708,0.96583-8.2083,6.4388-1.45,8.8538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m599.1,135.43c-7.0833-1.4488-12.233,2.7367-2.4125,6.2783"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m612.62,130.6c-9.9834-2.4146-14.008,0.16084-9.5,2.4146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m583.8,170.69c-0.32083,3.5417,1.6083,8.21,7.4042,2.8979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m585.74,181.31c0,0.96583-0.1625,2.0925-0.80833,2.8975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m562.55,134.14c-6.1167-1.7708-7.2417-7.405-0.15834-6.9221"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m560.46,147.18c-6.7625-2.2538-6.7625-8.8538-1.1292-8.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m573.02,143.8c-7.8875-1.9321-8.2083-7.4054-2.25-6.6004"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m573.98,127.06c-4.1833-0.32166-10.625,4.3467,0.1625,7.0833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m585.74,136.4c-9.8208-1.4488-9.6583,2.5758-3.8667,5.1517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m593.14,127.06c-7.5667-1.4488-10.142,3.0588-4.9917,4.9904"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m569.32,154.91c-1.8542-1.5288-3.3792-8.8542,5.4708-6.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m587.67,152.66c-5.9542-1.61-11.588,4.1854-6.1167,7.5658"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m595.55,145.74c-6.275-1.1271-11.588,0.64375-8.2083,2.8975"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m654.46,134.31c-3.5375,0.65541-6.7083,2.7342-8.7625,6.8396"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBt);
export default __webpack_public_path__ + "static/media/bt.ef7444a31a76d54b22af8dc1609e891c.svg";
export { ForwardRef as ReactComponent };